module.exports = __webpack_public_path__ + "img/update.f22a4a25.svg";